<template>
<div>
    <div class="innerBox">
            <div class="mb-4 row">
                <div class="col-md-5"></div>
                <div class="col-md-2">
                    <h3 
                        class="tableTitle text-left"
                        style="font: normal normal normal 16px/25px Poppins;">Jenik Truck</h3>
                </div>
                <div class="col-md-3"></div>
                <div class="col-md-2 text-right">
                    <button
                        class="btn rounded w-100"
                        type="button"
                        style="background-color: #CFECF9; font: normal normal normal 12px/18px Poppins;"
                        @click="modal.tambah = true"
                    >Tambah</button>
                </div>
            </div>

            <!-- Table Start -->
            <vue-universal-table
                api_url="/api/settings/list-container"
                :fields="vue_universal_table.fields"
                :update="vue_universal_table.update"
                :buttons="vue_universal_table.buttons"
                :infinite_scroll="true"

                sort_order="DESC"
                sort_by="created_at"
                style="font: normal normal normal 12px/18px Poppins;"

                @onEditDetails="openEditDetails"
                @onDelete="deleteMasterContainer"
            />
            <!-- Table End -->
        </div>

        <master-container-tambah 
            v-if="modal.tambah" 
            @refreshTable="vue_universal_table.update++" 
            @closeModal="modal.tambah = false" 
        />

        <master-container-update
            v-if="modal.edit"
            :data="modal.data"
            @refreshTable="vue_universal_table.update++"
            @closeModal="modal.edit = false; modal.data = null" 
        />
</div>  
</template>

<script>
import MasterContainerTambah from './children/MasterContainerTambah';
import MasterContainerUpdate from './children/MasterContainerUpdate';
export default {
    metaInfo : {
        title: 'Jenis Truck'
    },
    data() {
        return {
            modal : {
                data: null,
                tambah: false,
                edit: false
            },
            vue_universal_table: {
                fields: [
                    {title: 'Nama', variable: 'name'},
                    {title: 'Last Created', variable: 'created_at'}
                ],
                buttons: [
                    {title: 'editDetails', class: 'fas fa-pen btn-outline-primary'},
                    {title:"Delete", variable:"id", class:"fas fa-trash btn-outline-danger"},
                ],
                update: 0
            }
        }
    },
    methods: {
        openEditDetails (data) {
            this.modal.data = JSON.parse(data);
            this.modal.edit = true;
        },
        deleteMasterContainer (id) {
            this.$swal.fire({
                    title: 'Apakah Anda yakin?',
                    text: "data yang telah dihapus tidak dapat dikembalikan lagi",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085D6',
                    cancelButtonColor: '#D33',
                    confirmButtonText: 'Delete'
                }).then((result) => {
                    if (result.value) {
                        this.$http.delete(`/api/settings/delete-container/${id}`)
                        .then(()=>{
                            this.$swal.fire({
                                title : "Success!",
                                icon : "success",
                                type : "success",
                                text : `Truk container telah dihapus`
                            })
                            this.vue_universal_table.update++;
                        })
                        .catch((error)=>{
                            console.log('%cerror MasterCOntainer.vue line:78 ', 'color: red; display: block; width: 100%;', error);
                            this.$swal.fire({
                                title : "Error!",
                                icon : "error",
                                type : "error",
                                text : error.response.data.message
                            })
                        })
                    }
                })
        }
    },
    components: {
        MasterContainerTambah,
        MasterContainerUpdate
    }
}
</script>

<style scoped>
    .innerBox {
        background-color: white;
        border-radius: 8px;
        box-shadow: 0px 3px 10px #0000000F;
        padding: 20px;

    }

    .chart {
        background-color: white;
        border-radius: 8px;
        box-shadow: 0px 3px 10px #0000000F;
        padding: 20px;
        align-items: center;
    }

    .elegant--sub-title {
        font-size: 18px;
        font-weight: 500;
        color: #9F9F9F;
    }

    .tableTitle {
        text-align: center;
    }

    /* .center {
        padding: 50px 20px;
        display: flexbox;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    } */

    .stats--icon {
        display:flex; 
        align-items:center; 
        justify-content:center;
        text-align: center;
    }

    .table td, .table th{
        text-align: center;
    }
</style>